module.exports = function getResource(label, vars = []) {
    const resources = {
        add: 'Ajouter',
        buyOnlinePickUpTitle: `Achat en ligne et ramassage (${vars[0]}) `,
        storeDetails: 'Détails du magasin',
        bopisInfoTitle: 'Achetez en ligne et ramassez en magasin',
        certonaInfoTitle: `Également offert pour le ramassage à ce magasin :  ${vars[0]}`
    };

    return resources[label];
};
